// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SlugRouteImport } from './routes/$slug'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as GChar229TilRouteImport } from './routes/gå-til'
import { Route as KostenloseKreditkarteRouteImport } from './routes/kostenlose-kreditkarte'
import { Route as KreditkarteBeantragenRouteImport } from './routes/kreditkarte-beantragen'
import { Route as KreditkarteFuerStudentenRouteImport } from './routes/kreditkarte-fuer-studenten'
import { Route as KreditkarteOhneGirokontoRouteImport } from './routes/kreditkarte-ohne-girokonto'
import { Route as KreditkarteOhneSchufaRouteImport } from './routes/kreditkarte-ohne-schufa'
import { Route as MethodikRouteImport } from './routes/methodik'
import { Route as PrepaidKreditkarteRouteImport } from './routes/prepaid-kreditkarte'
import { Route as ReisekreditkarteRouteImport } from './routes/reisekreditkarte'
import { Route as UeberUnsRouteImport } from './routes/ueber-uns'
import { Route as ZumAnbieterRouteImport } from './routes/zum-anbieter'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminAdsRouteImport } from './routes/admin/ads'
import { Route as AdminArticleAdsRouteImport } from './routes/admin/article-ads'
import { Route as AdminArticlePlacementsRouteImport } from './routes/admin/article-placements'
import { Route as AdminArticleSectionRouteImport } from './routes/admin/article-section'
import { Route as AdminCardListingSettingsRouteImport } from './routes/admin/card-listing-settings'
import { Route as AdminCardPageSettingsRouteImport } from './routes/admin/card-page-settings'
import { Route as AdminCardTemplatesRouteImport } from './routes/admin/card-templates'
import { Route as AdminCardsRouteImport } from './routes/admin/cards'
import { Route as AdminCategoriesRouteImport } from './routes/admin/categories'
import { Route as AdminFeedRouteImport } from './routes/admin/feed'
import { Route as AdminFooterSettingsRouteImport } from './routes/admin/footer-settings'
import { Route as AdminHomepageContentRouteImport } from './routes/admin/homepage-content'
import { Route as AdminHomepageSettingsRouteImport } from './routes/admin/homepage-settings'
import { Route as AdminKortassistentRouteImport } from './routes/admin/kortassistent'
import { Route as AdminPlaygroundRouteImport } from './routes/admin/playground'
import { Route as AdminPopularCardsSectionRouteImport } from './routes/admin/popular-cards-section'
import { Route as AdminPromotedCardsRouteImport } from './routes/admin/promoted-cards'
import { Route as AdminRedirectSettingsRouteImport } from './routes/admin/redirect-settings'
import { Route as AdminRedirectsRouteImport } from './routes/admin/redirects'
import { Route as AdminSectionOrdersRouteImport } from './routes/admin/section-orders'
import { Route as AdminSeoInspectorRouteImport } from './routes/admin/seo-inspector'
import { Route as AdminSiteSettingsRouteImport } from './routes/admin/site-settings'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as ArtiklerIndexRouteImport } from './routes/artikler/index'
import { Route as ArtiklerSlugRouteImport } from './routes/artikler/$slug'
import { Route as KortIndexRouteImport } from './routes/kort/index'
import { Route as KortSlugRouteImport } from './routes/kort/$slug'
import { Route as KreditkartenIndexRouteImport } from './routes/kreditkarten/index'
import { Route as KreditkartenSlugRouteImport } from './routes/kreditkarten/$slug'
import { Route as RatgeberIndexRouteImport } from './routes/ratgeber/index'
import { Route as RatgeberSlugRouteImport } from './routes/ratgeber/$slug'
import { Route as ToolsKostenrechnerRouteImport } from './routes/tools/kostenrechner'
import { Route as ToolsKreditkartenFinderRouteImport } from './routes/tools/kreditkarten-finder'
import { Route as ToolsTeilzahlungsrechnerRouteImport } from './routes/tools/teilzahlungsrechner'
import { Route as AdminArticlesIndexRouteImport } from './routes/admin/articles/index'
import { Route as AdminArticlesNewRouteImport } from './routes/admin/articles/new'
import { Route as AdminArticlesIdEditRouteImport } from './routes/admin/articles/$id/edit'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const SlugRoute = SlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const GChar229TilRoute = GChar229TilRouteImport.update({
            id: '/gå-til',path: '/gå-til',getParentRoute: () => rootRouteImport
          })
const KostenloseKreditkarteRoute = KostenloseKreditkarteRouteImport.update({
            id: '/kostenlose-kreditkarte',path: '/kostenlose-kreditkarte',getParentRoute: () => rootRouteImport
          })
const KreditkarteBeantragenRoute = KreditkarteBeantragenRouteImport.update({
            id: '/kreditkarte-beantragen',path: '/kreditkarte-beantragen',getParentRoute: () => rootRouteImport
          })
const KreditkarteFuerStudentenRoute = KreditkarteFuerStudentenRouteImport.update({
            id: '/kreditkarte-fuer-studenten',path: '/kreditkarte-fuer-studenten',getParentRoute: () => rootRouteImport
          })
const KreditkarteOhneGirokontoRoute = KreditkarteOhneGirokontoRouteImport.update({
            id: '/kreditkarte-ohne-girokonto',path: '/kreditkarte-ohne-girokonto',getParentRoute: () => rootRouteImport
          })
const KreditkarteOhneSchufaRoute = KreditkarteOhneSchufaRouteImport.update({
            id: '/kreditkarte-ohne-schufa',path: '/kreditkarte-ohne-schufa',getParentRoute: () => rootRouteImport
          })
const MethodikRoute = MethodikRouteImport.update({
            id: '/methodik',path: '/methodik',getParentRoute: () => rootRouteImport
          })
const PrepaidKreditkarteRoute = PrepaidKreditkarteRouteImport.update({
            id: '/prepaid-kreditkarte',path: '/prepaid-kreditkarte',getParentRoute: () => rootRouteImport
          })
const ReisekreditkarteRoute = ReisekreditkarteRouteImport.update({
            id: '/reisekreditkarte',path: '/reisekreditkarte',getParentRoute: () => rootRouteImport
          })
const UeberUnsRoute = UeberUnsRouteImport.update({
            id: '/ueber-uns',path: '/ueber-uns',getParentRoute: () => rootRouteImport
          })
const ZumAnbieterRoute = ZumAnbieterRouteImport.update({
            id: '/zum-anbieter',path: '/zum-anbieter',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRoute
          })
const AdminAdsRoute = AdminAdsRouteImport.update({
            id: '/ads',path: '/ads',getParentRoute: () => AdminRoute
          })
const AdminArticleAdsRoute = AdminArticleAdsRouteImport.update({
            id: '/article-ads',path: '/article-ads',getParentRoute: () => AdminRoute
          })
const AdminArticlePlacementsRoute = AdminArticlePlacementsRouteImport.update({
            id: '/article-placements',path: '/article-placements',getParentRoute: () => AdminRoute
          })
const AdminArticleSectionRoute = AdminArticleSectionRouteImport.update({
            id: '/article-section',path: '/article-section',getParentRoute: () => AdminRoute
          })
const AdminCardListingSettingsRoute = AdminCardListingSettingsRouteImport.update({
            id: '/card-listing-settings',path: '/card-listing-settings',getParentRoute: () => AdminRoute
          })
const AdminCardPageSettingsRoute = AdminCardPageSettingsRouteImport.update({
            id: '/card-page-settings',path: '/card-page-settings',getParentRoute: () => AdminRoute
          })
const AdminCardTemplatesRoute = AdminCardTemplatesRouteImport.update({
            id: '/card-templates',path: '/card-templates',getParentRoute: () => AdminRoute
          })
const AdminCardsRoute = AdminCardsRouteImport.update({
            id: '/cards',path: '/cards',getParentRoute: () => AdminRoute
          })
const AdminCategoriesRoute = AdminCategoriesRouteImport.update({
            id: '/categories',path: '/categories',getParentRoute: () => AdminRoute
          })
const AdminFeedRoute = AdminFeedRouteImport.update({
            id: '/feed',path: '/feed',getParentRoute: () => AdminRoute
          })
const AdminFooterSettingsRoute = AdminFooterSettingsRouteImport.update({
            id: '/footer-settings',path: '/footer-settings',getParentRoute: () => AdminRoute
          })
const AdminHomepageContentRoute = AdminHomepageContentRouteImport.update({
            id: '/homepage-content',path: '/homepage-content',getParentRoute: () => AdminRoute
          })
const AdminHomepageSettingsRoute = AdminHomepageSettingsRouteImport.update({
            id: '/homepage-settings',path: '/homepage-settings',getParentRoute: () => AdminRoute
          })
const AdminKortassistentRoute = AdminKortassistentRouteImport.update({
            id: '/kortassistent',path: '/kortassistent',getParentRoute: () => AdminRoute
          })
const AdminPlaygroundRoute = AdminPlaygroundRouteImport.update({
            id: '/playground',path: '/playground',getParentRoute: () => AdminRoute
          })
const AdminPopularCardsSectionRoute = AdminPopularCardsSectionRouteImport.update({
            id: '/popular-cards-section',path: '/popular-cards-section',getParentRoute: () => AdminRoute
          })
const AdminPromotedCardsRoute = AdminPromotedCardsRouteImport.update({
            id: '/promoted-cards',path: '/promoted-cards',getParentRoute: () => AdminRoute
          })
const AdminRedirectSettingsRoute = AdminRedirectSettingsRouteImport.update({
            id: '/redirect-settings',path: '/redirect-settings',getParentRoute: () => AdminRoute
          })
const AdminRedirectsRoute = AdminRedirectsRouteImport.update({
            id: '/redirects',path: '/redirects',getParentRoute: () => AdminRoute
          })
const AdminSectionOrdersRoute = AdminSectionOrdersRouteImport.update({
            id: '/section-orders',path: '/section-orders',getParentRoute: () => AdminRoute
          })
const AdminSeoInspectorRoute = AdminSeoInspectorRouteImport.update({
            id: '/seo-inspector',path: '/seo-inspector',getParentRoute: () => AdminRoute
          })
const AdminSiteSettingsRoute = AdminSiteSettingsRouteImport.update({
            id: '/site-settings',path: '/site-settings',getParentRoute: () => AdminRoute
          })
const AdminUsersRoute = AdminUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => AdminRoute
          })
const ArtiklerIndexRoute = ArtiklerIndexRouteImport.update({
            id: '/artikler/',path: '/artikler/',getParentRoute: () => rootRouteImport
          })
const ArtiklerSlugRoute = ArtiklerSlugRouteImport.update({
            id: '/artikler/$slug',path: '/artikler/$slug',getParentRoute: () => rootRouteImport
          })
const KortIndexRoute = KortIndexRouteImport.update({
            id: '/kort/',path: '/kort/',getParentRoute: () => rootRouteImport
          })
const KortSlugRoute = KortSlugRouteImport.update({
            id: '/kort/$slug',path: '/kort/$slug',getParentRoute: () => rootRouteImport
          })
const KreditkartenIndexRoute = KreditkartenIndexRouteImport.update({
            id: '/kreditkarten/',path: '/kreditkarten/',getParentRoute: () => rootRouteImport
          })
const KreditkartenSlugRoute = KreditkartenSlugRouteImport.update({
            id: '/kreditkarten/$slug',path: '/kreditkarten/$slug',getParentRoute: () => rootRouteImport
          })
const RatgeberIndexRoute = RatgeberIndexRouteImport.update({
            id: '/ratgeber/',path: '/ratgeber/',getParentRoute: () => rootRouteImport
          })
const RatgeberSlugRoute = RatgeberSlugRouteImport.update({
            id: '/ratgeber/$slug',path: '/ratgeber/$slug',getParentRoute: () => rootRouteImport
          })
const ToolsKostenrechnerRoute = ToolsKostenrechnerRouteImport.update({
            id: '/tools/kostenrechner',path: '/tools/kostenrechner',getParentRoute: () => rootRouteImport
          })
const ToolsKreditkartenFinderRoute = ToolsKreditkartenFinderRouteImport.update({
            id: '/tools/kreditkarten-finder',path: '/tools/kreditkarten-finder',getParentRoute: () => rootRouteImport
          })
const ToolsTeilzahlungsrechnerRoute = ToolsTeilzahlungsrechnerRouteImport.update({
            id: '/tools/teilzahlungsrechner',path: '/tools/teilzahlungsrechner',getParentRoute: () => rootRouteImport
          })
const AdminArticlesIndexRoute = AdminArticlesIndexRouteImport.update({
            id: '/articles/',path: '/articles/',getParentRoute: () => AdminRoute
          })
const AdminArticlesNewRoute = AdminArticlesNewRouteImport.update({
            id: '/articles/new',path: '/articles/new',getParentRoute: () => AdminRoute
          })
const AdminArticlesIdEditRoute = AdminArticlesIdEditRouteImport.update({
            id: '/articles/$id/edit',path: '/articles/$id/edit',getParentRoute: () => AdminRoute
          })





const AdminRouteChildren = {
  AdminAdsRoute: AdminAdsRoute,AdminArticleAdsRoute: AdminArticleAdsRoute,AdminArticlePlacementsRoute: AdminArticlePlacementsRoute,AdminArticleSectionRoute: AdminArticleSectionRoute,AdminCardListingSettingsRoute: AdminCardListingSettingsRoute,AdminCardPageSettingsRoute: AdminCardPageSettingsRoute,AdminCardTemplatesRoute: AdminCardTemplatesRoute,AdminCardsRoute: AdminCardsRoute,AdminCategoriesRoute: AdminCategoriesRoute,AdminFeedRoute: AdminFeedRoute,AdminFooterSettingsRoute: AdminFooterSettingsRoute,AdminHomepageContentRoute: AdminHomepageContentRoute,AdminHomepageSettingsRoute: AdminHomepageSettingsRoute,AdminKortassistentRoute: AdminKortassistentRoute,AdminPlaygroundRoute: AdminPlaygroundRoute,AdminPopularCardsSectionRoute: AdminPopularCardsSectionRoute,AdminPromotedCardsRoute: AdminPromotedCardsRoute,AdminRedirectSettingsRoute: AdminRedirectSettingsRoute,AdminRedirectsRoute: AdminRedirectsRoute,AdminSectionOrdersRoute: AdminSectionOrdersRoute,AdminSeoInspectorRoute: AdminSeoInspectorRoute,AdminSiteSettingsRoute: AdminSiteSettingsRoute,AdminUsersRoute: AdminUsersRoute,AdminIndexRoute: AdminIndexRoute,AdminArticlesNewRoute: AdminArticlesNewRoute,AdminArticlesIndexRoute: AdminArticlesIndexRoute,AdminArticlesIdEditRoute: AdminArticlesIdEditRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,SlugRoute: SlugRoute,AdminRoute: AdminRouteWithChildren,AuthRoute: AuthRoute,GChar229TilRoute: GChar229TilRoute,KostenloseKreditkarteRoute: KostenloseKreditkarteRoute,KreditkarteBeantragenRoute: KreditkarteBeantragenRoute,KreditkarteFuerStudentenRoute: KreditkarteFuerStudentenRoute,KreditkarteOhneGirokontoRoute: KreditkarteOhneGirokontoRoute,KreditkarteOhneSchufaRoute: KreditkarteOhneSchufaRoute,MethodikRoute: MethodikRoute,PrepaidKreditkarteRoute: PrepaidKreditkarteRoute,ReisekreditkarteRoute: ReisekreditkarteRoute,UeberUnsRoute: UeberUnsRoute,ZumAnbieterRoute: ZumAnbieterRoute,ArtiklerSlugRoute: ArtiklerSlugRoute,KortSlugRoute: KortSlugRoute,KreditkartenSlugRoute: KreditkartenSlugRoute,RatgeberSlugRoute: RatgeberSlugRoute,ToolsKostenrechnerRoute: ToolsKostenrechnerRoute,ToolsKreditkartenFinderRoute: ToolsKreditkartenFinderRoute,ToolsTeilzahlungsrechnerRoute: ToolsTeilzahlungsrechnerRoute,ArtiklerIndexRoute: ArtiklerIndexRoute,KortIndexRoute: KortIndexRoute,KreditkartenIndexRoute: KreditkartenIndexRoute,RatgeberIndexRoute: RatgeberIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)